import { render, staticRenderFns } from "./cocaunhansu.vue?vue&type=template&id=67302285"
import script from "./cocaunhansu.vue?vue&type=script&lang=js"
export * from "./cocaunhansu.vue?vue&type=script&lang=js"
import style0 from "./cocaunhansu.vue?vue&type=style&index=0&id=67302285&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports